export default {
  zh: {
    recharge_activity: '充值活动',
    rules: '规则',
    recharge_activity_rules_1: '1.充值活动时间：每月1日00:00:00至最后一天23:59:59(GMT+3)。',
    recharge_activity_rules_2: '2. 每个等级只能领取一次。',
    recharge_activity_rules_3: '3.活动结束后，未获得的奖励将作废。',
    recharge_activity_rules_4: '4. 请联系管理员用户(whatsapp:+44 7707115144) 获取特殊ID。',
    my_monthly_recharge: '我的每月充值',
    my_monthly_recharge_rule1: (coins) =>
      `1.充值金币包括渠道：谷歌、苹果、华为+充值链接(payermax,paypal)+充值代理,APP内充值金币(充值1美元=${coins}金币)`,
    my_monthly_recharge_rule2: '2、币商不参与充值活动奖励',
    days: '天',
    hours: '小时',
    minutes: '分钟',
    seconds: '秒',
    'recharge_9.9': '充值$9.9',
    receive: '获得',
    received: '已获得',
    recharge_label: '充值',
    receive_successfully_toast: '领取成功，您的奖励已发送至您的背包',
    receive_failed_toast: '领取失败，请稍后重试',
    'recharge_49.9': '充值$49.9',
    recharge_100: '充值$100',
    top3_winners: '前3获得者',
    recharge_300: '充值$300',
    recharge_500: '充值$500',
    recharge_1000: '充值$1000',
    recharge_1500: '充值$1500',
    recharge_3000: '充值$3000',
    eid_al_adha_events_button_introduction_1: '本次活动解释权归 Yayya 所有',
    eid_al_adha_events_button_introduction_2: '本活动与APPLE无关',
    nineAdd: 'Recharge 9.9+',
    threeAdd: 'Recharge 3000+',
    fiveAdd: 'Recharge 500+',
    gift_icon_tost: '您可以向官方提供您自己的独家视频作为您的定制礼物。',
    customized_gifts_title: '定制礼物',
  },
  en: {
    recharge_activity: 'Recharge activity',
    rules: 'Rules',
    recharge_activity_rules_1:
      '1. Recharge activity time: Every From 00:00:00 on the 1st of every month to 23:59:59 on the last day(GMT+3).',
    recharge_activity_rules_2: '2. You can only claim once per level.',
    recharge_activity_rules_3: '3. At the end of the event,the unobtained rewards will be invaild.',
    recharge_activity_rules_4:
      '4. Please contact administartor user(whatsapp:+44 7707115144) to obtain a special ID.',
    my_monthly_recharge: 'My monthly recharge',
    my_monthly_recharge_rule1: (coins) =>
      `1. Recharge coins include channels:Google,Apple,huawei+recharge link(payermax,paypal)+recharge agent recharge coins in the APP(recharge $1=${coins} coins)`,
    my_monthly_recharge_rule2:
      '2. Currency merchants do not participate in recharge activity rewards',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    'recharge_9.9': 'Recharge $9.9',
    receive: 'Receive',
    received: 'Received',
    recharge_label: 'Recharge',
    receive_successfully_toast: 'Received successfully, your reward has been sent to your backpack',
    receive_failed_toast: 'Received failed, please try again later',
    'recharge_49.9': 'Recharge $49.9',
    recharge_100: 'Recharge $100',
    top3_winners: 'TOP3 winners',
    recharge_300: 'Recharge $300',
    recharge_500: 'Recharge $500',
    recharge_1000: 'Recharge $1000',
    recharge_1500: 'Recharge $1500',
    recharge_3000: 'Recharge $3000',
    recharge_5000: 'Recharge $5000',
    recharge_10000: 'Recharge $10000',
    eid_al_adha_events_button_introduction_1:
      'The final interpretation right of this activity belongs to Yayya',
    eid_al_adha_events_button_introduction_2: 'This activity has nothing to do with APPLE',
    nineAdd: 'Recharge $9.9+',
    threeAdd: 'Recharge $3000+',
    fiveAdd: 'Recharge $500+',
    gift_icon_tost: 'You can provide your own exclusive video to official as your customized gift.',
    customized_gifts_title: 'Customized Gifts',
  },
  ar: {
    recharge_activity: 'نشاط إعادة  الشحن',
    rules: 'القواعد',
    recharge_activity_rules_1:
      '1. وقت نشاط إعادة الشحن: 00:00:00 في اليوم الأول من كل شهر إلى 23:59:59 في اليوم الأخير (GMT+3).',
    recharge_activity_rules_2: '2. يمكن الاستلام بكل مستوى مرة واحدة فقط.',
    recharge_activity_rules_3: '3. بعد انتهاء الحدث، سيتم مصادرة أي مكافآت غير مكتسبة.',
    recharge_activity_rules_4:
      '4. يرجى الاتصال بالمسؤول (whatsapp:+44 7707115144) للحصول على الايدي المميز.',
    my_monthly_recharge: 'شحني الشهري',
    my_monthly_recharge_rule1: (coins) =>
      `1. تتضمن إعادة شحن الكونزات القنوات: Google وApple وHuawei + رابط إعادة الشحن (payermax وpaypal) + إعادة شحن  الكونزات في تطبيق و,وكالة الشحن(إعادة شحن 1 دولار  = ${coins} كونزات)`,
    my_monthly_recharge_rule2: '2. لا يشارك وكالة  الشحن في  نشاط إعادة الشحن',
    days: 'يوم',
    hours: 'ساعة',
    minutes: 'دقيقة',
    seconds: 'ثوان',
    'recharge_9.9': 'شحن 9.9$',
    receive: 'استلام',
    received: 'تم  استلام',
    recharge_label: 'شحن',
    receive_successfully_toast: 'تم استلام المكافأة بنجاح، وتم إرسال مكافأتك إلى حقيبة ظهرك',
    receive_failed_toast: 'فشل الاستلام، يرجى المحاولة مرة أخرى لاحقًا',
    'recharge_49.9': 'شحن 49.9$',
    recharge_100: 'شحن 100$',
    top3_winners: 'أعلي ثلاثة',
    recharge_300: 'شحن 300$',
    recharge_500: 'شحن 500$',
    recharge_1000: 'شحن 1000$',
    recharge_1500: 'شحن 1500$',
    recharge_3000: 'شحن 3000$',
    recharge_5000: 'شحن 5000$',
    recharge_10000: 'شحن 10000$',
    eid_al_adha_events_button_introduction_1: 'الحق النهائي في تفسير هذا النشاط يعود إلى Yayya',
    eid_al_adha_events_button_introduction_2: 'هذا النشاط ليس له علاقة بشركة APPLE',
    nineAdd: '+شحن 9.9$',
    threeAdd: '+شحن 3000$',
    fiveAdd: '+شحن 500$',
    gift_icon_tost: 'يمكنك تقديم الفيديو الحصري الخاص بك إلى المسؤول كهدية مخصصة لك.',
    customized_gifts_title: 'الهدية  المخصصة',
  },
  tr: {
    recharge_activity: 'Yükleme Etkinliği',
    rules: 'Kurallar',
    recharge_activity_rules_1:
      "1. Çekim Etkinlik Süresi: Her ayın 1'inde saat 00:00:00'dan son gün saat 23:59:59'a (GMT+3) kadar.",
    recharge_activity_rules_2: '2. Seviye başına yalnızca bir kez talepte bulunabilirsiniz.',
    recharge_activity_rules_3: '3. Etkinlik sonunda alınlayan ödüller geçersiz olacaktır.',
    recharge_activity_rules_4:
      '4. Özel bir kimlik almak için lütfen yöneticiyle (WhatsApp: +44 7707115144) iletişime geçin.',
    my_monthly_recharge: 'Aylık Çekimim',
    my_monthly_recharge_rule1: (coins) =>
      `1. Altın çekim kanalları şunları içerir: Google, Apple, Huawei+Link (payermax,paypal)+APP'deki altınları Çekim aracısı (1 $ = ${coins} coins )`,
    my_monthly_recharge_rule2: ' 2. Coins bayileri çekim etkinliği ödüllerine katılmaz',
    days: 'Gün',
    hours: 'Saat',
    minutes: 'Dakika',
    seconds: 'Saniye',
    'recharge_9.9': 'Çekim $9.9',
    receive: 'Al',
    received: 'Alındı',
    recharge_label: 'Çekim',
    receive_successfully_toast: 'Başarıyla alındı, ödülünüz çantanıza gönderildi',
    receive_failed_toast: 'Alma başarısız, lütfen daha sonra tekrar deneyin',
    'recharge_49.9': 'Çekim $49.9',
    recharge_100: 'Çekim $100',
    top3_winners: 'İlk 3 Kazanan',
    recharge_300: 'Çekim $300',
    recharge_500: 'Çekim $500',
    recharge_1000: 'Çekim $1000',
    recharge_1500: 'Çekim $1500',
    recharge_3000: 'Çekim $3000',
    recharge_5000: 'Çekim $5000',
    recharge_10000: 'Çekim $10000',
    eid_al_adha_events_button_introduction_1: "Bu etkinliğin son yorumlama hakkı Yayya'e aittir.",
    eid_al_adha_events_button_introduction_2: 'Bu etkinliğin APPLE ile hiçbir ilgisi yoktur',
    nineAdd: 'Çekim $9.9+',
    threeAdd: 'Çekim $3000+',
    fiveAdd: 'Çekim $500+',
    gift_icon_tost:
      'Kişiselleştirilmiş hediyeniz olarak kendi özel videonuzu görevliye sağlayabilirsiniz.',
    customized_gifts_title: 'Özel Hediyeler',
  },
  pt: {
    recharge_activity: 'Atividade de recarga',
    rules: 'Regras',
    recharge_activity_rules_1:
      '1. Tempo da atividade de recarga: De 00:00:00 no primeiro dia de cada mês até 23:59:59 no último dia (GMT+3).',
    recharge_activity_rules_2: '2. Você pode reivindicar apenas uma vez por nível.',
    recharge_activity_rules_3:
      '3. Ao final do evento, as recompensas não obtidas se tornarão inválidas.',
    recharge_activity_rules_4:
      '4. Por favor, entre em contato com o administrador (whatsapp:+44 7707115144) para obter um ID especial.',
    my_monthly_recharge: 'Minha recarga mensal',
    my_monthly_recharge_rule1: (coins) =>
      `1. Moedas de recarga incluem canais: Google, Apple, Huawei + link de recarga (payermax, paypal) + moedas de recarga de agentes de recarga no APP (recarga de $1 = ${coins} moedas)`,
    my_monthly_recharge_rule2:
      '2. Comerciantes de moeda não participam das recompensas da atividade de recarga',
    days: 'Dias',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    'recharge_9.9': 'Recarga de $9.9',
    receive: 'Receber',
    received: 'Recebido',
    recharge_label: 'Recarga',
    receive_successfully_toast: 'Recebido com sucesso, sua recompensa foi enviada para sua mochila',
    receive_failed_toast: 'Falha ao receber, por favor, tente novamente mais tarde',
    'recharge_49.9': 'Recarga de $49.9',
    recharge_100: 'Recarga de $100',
    top3_winners: 'Vencedores do TOP3',
    recharge_300: 'Recarga de $300',
    recharge_500: 'Recarga de $500',
    recharge_1000: 'Recarga de $1000',
    recharge_1500: 'Recarga de $1500',
    recharge_3000: 'Recarga de $3000',
    recharge_5000: 'Recarga de $5000',
    recharge_10000: 'Recarga de $10000',
    eid_al_adha_events_button_introduction_1:
      'O direito de interpretação final desta atividade pertence à Yayya',
    eid_al_adha_events_button_introduction_2: 'Esta atividade não tem nada a ver com a APPLE',
    nineAdd: 'Recarga de $9.9+',
    threeAdd: 'Recarga de $3000+',
    fiveAdd: 'Recarga de $500+',
    gift_icon_tost:
      'Você pode fornecer seu próprio vídeo exclusivo para a oficial como seu presente personalizado.',
    customized_gifts_title: 'Presentes Personalizados',
  },
  id: {
    recharge_activity: 'Aktivitas pengisian ulang',
    rules: 'Aturan',
    recharge_activity_rules_1:
      '1. Waktu aktivitas pengisian ulang: Setiap mulai dari 00:00:00 pada tanggal 1 setiap bulan hingga 23:59:59 pada hari terakhir (GMT+3).',
    recharge_activity_rules_2: '2. Anda hanya dapat mengklaim sekali per level.',
    recharge_activity_rules_3:
      '3. Pada akhir acara, hadiah yang tidak didapatkan akan menjadi tidak berlaku.',
    recharge_activity_rules_4:
      '4. Silakan hubungi pengguna administrator (whatsapp:+44 7707115144) untuk mendapatkan ID khusus.',
    my_monthly_recharge: 'Pengisian ulang bulanan saya',
    my_monthly_recharge_rule1: (coins) =>
      `1. Koin pengisian ulang mencakup saluran: Google, Apple, Huawei + tautan pengisian ulang (payermax, paypal) + koin pengisian ulang agen pengisian ulang di APP (pengisian ulang $1 = ${coins} koin)`,
    my_monthly_recharge_rule2:
      '2. Pedagang mata uang tidak berpartisipasi dalam hadiah aktivitas pengisian ulang',
    days: 'Hari',
    hours: 'Jam',
    minutes: 'Menit',
    seconds: 'Detik',
    'recharge_9.9': 'Pengisian ulang $9.9',
    receive: 'Terima',
    received: 'Diterima',
    recharge_label: 'Pengisian ulang',
    receive_successfully_toast: 'Berhasil diterima, hadiah Anda telah dikirim ke ransel Anda',
    receive_failed_toast: 'Gagal menerima, silakan coba lagi nanti',
    'recharge_49.9': 'Pengisian ulang $49.9',
    recharge_100: 'Pengisian ulang $100',
    top3_winners: 'Pemenang TOP3',
    recharge_300: 'Pengisian ulang $300',
    recharge_500: 'Pengisian ulang $500',
    recharge_1000: 'Pengisian ulang $1000',
    recharge_1500: 'Pengisian ulang $1500',
    recharge_3000: 'Pengisian ulang $3000',
    recharge_5000: 'Pengisian ulang $5000',
    recharge_10000: 'Pengisian ulang $10000',
    eid_al_adha_events_button_introduction_1:
      'Hak penafsiran akhir dari aktivitas ini adalah milik Yayya',
    eid_al_adha_events_button_introduction_2: 'Aktivitas ini tidak ada hubungannya dengan APPLE',
    nineAdd: 'Pengisian ulang $9.9+',
    threeAdd: 'Pengisian ulang $3000+',
    fiveAdd: 'Pengisian ulang $500+',
    gift_icon_tost:
      'Anda dapat memberikan video eksklusif Anda sendiri kepada resmi sebagai hadiah khusus Anda.',
    customized_gifts_title: 'Hadiah Kustomisasi',
  },
  uz: {
    recharge_activity: 'Zaryadlash faoliyati',
    rules: 'Qoidalar',
    recharge_activity_rules_1:
      '1. Zaryadlash vaqti: Har oyning 1 kuni soat 00:00:00 dan oxirgi kun 23:59:59 gacha (GMT+3).',
    recharge_activity_rules_2:
      '2. 10 000 AQSh dollarigacha toʻldirganingizda, oʻzingizning eksklyuziv videongizni moslashtirilgan sovgʻa sifatida taqdim etishingiz mumkin.',
    recharge_activity_rules_3: '3. Har bir daraja uchun faqat bir marta daʼvo qilishingiz mumkin.',
    recharge_activity_rules_4:
      '5. Maxsus ID olish uchun administrator foydalanuvchisiga (whatsapp:+44 7707115144) murojaat qiling.',
    my_monthly_recharge: "Mening oylik to'lovim",
    my_monthly_recharge_rule1: (coins) =>
      `1. To'lov tangalari quyidagi kanallarni o'z ichiga oladi: Google, Apple, Huawei + to'lov havolasi (payermax, paypal) + ilovadagi agent orqali to'lov tangalari (to'lov $1 = ${coins} tanga)`,
    my_monthly_recharge_rule2:
      "2. Valyuta savdogarlari to'lov faoliyatining mukofotlarida ishtirok etmaydi",
    days: 'Kunlar',
    hours: 'Soatlar',
    minutes: 'Daqiqalar',
    seconds: 'Soniyalar',
    'recharge_9.9': "To'lov $9.9",
    receive: 'Qabul qilish',
    received: 'Qabul qilingan',
    receive_successfully_toast:
      'Muvaffaqiyatli qabul qilindi, mukofotingiz ranselingizga yuborildi',
    receive_failed_toast: "Qabul qilishda xato yuz berdi, iltimos, keyinroq qayta urinib ko'ring",
    'recharge_49.9': "To'lov $49.9",
    recharge_100: "To'lov $100",
    top3_winners: "TOP3 g'oliblari",
    recharge_300: "To'lov $300",
    recharge_500: "To'lov $500",
    recharge_1000: "To'lov $1000",
    recharge_1500: "To'lov $1500",
    recharge_3000: "To'lov $3000",
    recharge_5000: "To'lov $5000",
    recharge_10000: "To'lov $10000",
    eid_al_adha_events_button_introduction_1:
      'Bu faoliyatning yakuniy tushuntirish huquqi Hobyga tegishlidir',
    eid_al_adha_events_button_introduction_2: "Bu faoliyat APPLE bilan bog'liq emas",
    nineAdd: "To'lov $9.9+",
    threeAdd: "To'lov $3000+",
    fiveAdd: "To'lov $500+",
    gift_icon_tost:
      "Siz o'zingizning maxsus videongizni rasmiylarga o'zining moslashtirilgan sovg'asi sifatida taqdim etishingiz mumkin.",
    customized_gifts_title: "Maxsus Sovg'alar",
  },
  ru: {
    recharge_activity: 'Мероприятие по пополнению',
    rules: 'Правила',
    recharge_activity_rules_1:
      '1.Время мероприятия по пополнению：С 00:00:00 1-го числа каждого месяца до 23:59:59 (GMT+3) в последний день каждого месяца.',
    recharge_activity_rules_2:
      '2. Когда вы пополните счет до  $10,000, вы сможете предоставить свое собственное видео в качестве индивидуального подарка.',
    recharge_activity_rules_3: '3. Вы можете претендовать только один раз за уровень.',
    // "recharge_activity_rules_4": "4. По окончании мероприятия неполученные награды будут недействительны.",
    my_monthly_recharge: 'Пополнение месяца',
    recharge_activity_rules_4:
      '4. Пожалуйста, свяжитесь с администратором (WhatsApp +44 7707115144) для получения уникального ID.',
    my_monthly_recharge_rule1: (coins) =>
      `1.Пополнение осуществляется через следующие каналы: Google, Apple, Huawei + ссылка для пополнения счета (payermax, PayPal) + пополнение через реселлеров, пополнение в приложении Yayya ( $1 = ${coins} золотых монет).`,
    my_monthly_recharge_rule2: '',
    '2. Currency merchants do not participate in recharge activity rewards"': '',
    days: 'Дни',
    hours: 'Часы',
    minutes: 'Минуты',
    seconds: 'Секунды',
    'recharge_9.9': 'Пополнение на $9,9',
    headwear_7days: 'головной убор*7 дней',
    vehicle_7days: 'драйв*7 дней',
    receive: 'Получать',
    received: 'Полученный',
    receive_successfully_toast: 'Получено успешно, ваша награда отправлена ​​в ваш рюкзак',
    receive_failed_toast: 'Ошибка получения, повторите попытку позже.',
    'recharge_49.9': 'Пополнение на $49,9',
    vip1_7days: 'VIP1*7 дней',
    recharge_100: 'Пополнение на $100',
    vip1_15days: 'VIP1*15 дней',
    top3_winners: 'ТОП-3 победителей',
    recharge_300: 'Пополнение на $300',
    vip2_7days: 'VIP2*7 дней',
    recharge_500: 'Пополнение на $500',
    vip2_15days: 'VIP2*15 дней',
    recharge_1000: 'Пополнение на $1000',
    vip3_7days: 'VIP3*7 дней',
    recharge_1500: 'Пополнение на $1500',
    vip3_15days: 'VIP3*15 дней',
    recharge_3000: 'Пополнение на $3000',
    pretty_id_30_days: 'Крутой айди*30 дней',
    customized_gifts_15_ays: 'индивидуальный подарок*15 дней',
    'vip4_15days ': 'VIP4*15 дней',
    recharge_5000: 'Пополнение на $5000',
    open_screen_7_days: 'Открытый экран*7 дней',
    banner_15days: 'Баннер*15 дней',
    customized_gifts_30_days: 'индивидуальный подарок*30 дней',
    customized_vehicle_15_days: 'индивидуальный драйв * 15 дней',
    customized_headwear_15_days: 'индивидуальный головной убор * 15 дней',
    vip5_7days: 'VIP5*7 дней',
    recharge_10000: 'Пополнение на $10000',
    open_screen_15_days: 'Открытый экран*15 дней',
    recharge_activity_button_introduction_1:
      'Окончательное право на интерпретацию этого мероприятия принадлежит Yayya.',
    recharge_activity_button_introduction_2: 'Это мероприятие не имеет никакого отношения к APPLE.',
    recharge_activity_message1:
      'Поздравляем с ежемесячным пополнением баланса в размере {0} $ и с получением {1}. Подойдите к своему рюкзаку, чтобы проверить и использовать его~',
    '5_days': '5 дней',
    '7_days': '7 дней',
    '15_days': '15 дней',
    '30_days': '30 дней',
    '1w_customized_gift_toast':
      'Вы можете предоставить официальному лицу свое видео в качестве индивидуального подарка.',
    customized_gifts_rules: 'индивидуальный подарок',
    nineAdd: 'Пополнить 9.9+',
    threeAdd: 'Пополнить 3000+',
    fiveAdd: 'Пополнить 500+',
  },
  fa: {
    recharge_activity: 'فعالیت شارژ',
    rules: 'قوانین',
    recharge_activity_rules_1:
      '1. زمان فعالیت شارژ: از 00:00:00 روز اول هر ماه تا 23:59:59 روز آخر (GMT+3).',
    recharge_activity_rules_2: '2. شما فقط می‌توانید هر سطح را یک بار درخواست کنید.',
    recharge_activity_rules_3: '3. در پایان رویداد، جوایز دریافت نشده غیرقابل استفاده خواهند بود.',
    recharge_activity_rules_4:
      '4. لطفاً با کاربر مدیر (whatsapp:+44 7707115144) تماس بگیرید تا یک شناسه خاص دریافت کنید.',
    my_monthly_recharge: 'شارژ ماهانه من',
    my_monthly_recharge_rule1: (coins) =>
      `1. کانال‌های شارژ شامل: Google، Apple، Huawei + لینک شارژ (payermax، paypal) + شارژ از طریق نماینده در اپلیکیشن (شارژ $1 = ${coins} سکه)`,
    my_monthly_recharge_rule2: '2. تجار ارز در جوایز فعالیت شارژ شرکت نمی‌کنند',
    days: 'روزها',
    hours: 'ساعت‌ها',
    minutes: 'دقیقه‌ها',
    seconds: 'ثانیه‌ها',
    'recharge_9.9': 'شارژ $9.9',
    receive: 'دریافت',
    received: 'دریافت شده',
    receive_successfully_toast: 'دریافت با موفقیت، جایزه شما به کوله‌پشتی شما ارسال شد',
    receive_failed_toast: 'دریافت ناموفق بود، لطفاً بعداً دوباره تلاش کنید',
    'recharge_49.9': 'شارژ $49.9',
    recharge_100: 'شارژ $100',
    top3_winners: 'برندگان TOP3',
    recharge_300: 'شارژ $300',
    recharge_500: 'شارژ $500',
    recharge_1000: 'شارژ $1000',
    recharge_1500: 'شارژ $1500',
    recharge_3000: 'شارژ $3000',
    recharge_5000: 'شارژ $5000',
    recharge_10000: 'شارژ $10000',
    eid_al_adha_events_button_introduction_1: 'حق تفسیر نهایی این فعالیت متعلق به Yayya است',
    eid_al_adha_events_button_introduction_2: 'این فعالیت هیچ ارتباطی با APPLE ندارد',
    nineAdd: 'شارژ $9.9+',
    threeAdd: 'شارژ $3000+',
    fiveAdd: 'شارژ $500+',
    gift_icon_tost:
      'شما می‌توانید ویدئوی اختصاصی خود را به طور رسمی به عنوان هدیه سفارشی شده خود ارسال کنید.',
    customized_gifts_title: 'هدایای سفارشی شده',
  },
  ur: {
    recharge_activity: 'ریچارج سرگرمی',
    rules: 'قواعد',
    recharge_activity_rules_1:
      '1. ریچارج سرگرمی کا وقت: ہر ماہ کی پہلی تاریخ کو 00:00:00 سے آخری دن 23:59:59 تک (GMT+3)۔',
    recharge_activity_rules_2: '2. آپ ہر لیول پر صرف ایک بار انعام حاصل کر سکتے ہیں۔',
    recharge_activity_rules_3: '3. ایونٹ کے اختتام پر، غیر حاصل شدہ انعامات کالعدم ہو جائیں گے۔',
    recharge_activity_rules_4:
      '4. خصوصی ID حاصل کرنے کے لیے براہ کرم ایڈمنسٹریٹر صارف سے رابطہ کریں (واٹس ایپ: +44 7707115144)۔',
    my_monthly_recharge: 'میرا ماہانہ ریچارج',
    my_monthly_recharge_rule1: (coins) =>
      `1. ریچارج سکے میں شامل چینلز: گوگل، ایپل، ہواوے + ریچارج لنک (پے ایر میکس، پے پال) + ایپ میں ریچارج ایجنٹ کے ذریعے ریچارج سکے ($1 = ${coins} سکے)۔`,
    my_monthly_recharge_rule2: '2. کرنسی کے تاجر ریچارج سرگرمی کے انعامات میں حصہ نہیں لیتے۔',
    days: 'دن',
    hours: 'گھنٹے',
    minutes: 'منٹ',
    seconds: 'سیکنڈ',
    'recharge_9.9': '$9.9 ریچارج کریں',
    receive: 'وصول کریں',
    received: 'موصول ہو چکا',
    receive_successfully_toast:
      'کامیابی سے وصول ہوا، آپ کا انعام آپ کے بیک پیک میں بھیج دیا گیا ہے',
    receive_failed_toast: 'وصول کرنے میں ناکامی، براہ کرم بعد میں کوشش کریں',
    'recharge_49.9': '$49.9 ریچارج کریں',
    recharge_100: '$100 ریچارج کریں',
    top3_winners: 'ٹاپ 3 فاتحین',
    recharge_300: '$300 ریچارج کریں',
    recharge_500: '$500 ریچارج کریں',
    recharge_1000: '$1000 ریچارج کریں',
    recharge_1500: '$1500 ریچارج کریں',
    recharge_3000: '$3000 ریچارج کریں',
    recharge_5000: '$5000 ریچارج کریں',
    recharge_10000: '$10000 ریچارج کریں',
    eid_al_adha_events_button_introduction_1: 'اس سرگرمی کی حتمی تشریح کا حق Yayya کے پاس ہے',
    eid_al_adha_events_button_introduction_2: 'اس سرگرمی کا ایپل سے کوئی تعلق نہیں ہے',
    nineAdd: '$9.9+ ریچارج کریں',
    threeAdd: '$3000+ ریچارج کریں',
    fiveAdd: '$500+ ریچارج کریں',
    gift_icon_tost: 'آپ اپنا خصوصی ویڈیو بطور اپنی مرضی کا تحفہ سرکاری طور پر فراہم کر سکتے ہیں۔',
    customized_gifts_title: 'اپنی مرضی کے تحائف',
  },
  bn: {
    recharge_activity: 'রিচার্জ কার্যকলাপ',
    rules: 'নিয়ম',
    recharge_activity_rules_1:
      '১. রিচার্জ কার্যকলাপের সময়: প্রতি মাসের ১ তারিখ 00:00:00 থেকে শেষ দিন 23:59:59 পর্যন্ত (GMT+3)।',
    recharge_activity_rules_2: '২. আপনি প্রতিটি স্তরে শুধুমাত্র একবার দাবি করতে পারবেন।',
    recharge_activity_rules_3: '৩. ইভেন্ট শেষে, অপ্রাপ্ত পুরস্কার বাতিল হয়ে যাবে।',
    recharge_activity_rules_4:
      '৪. বিশেষ ID পেতে অ্যাডমিন ব্যবহারকারীর সাথে যোগাযোগ করুন (whatsapp:+44 7707115144)।',
    my_monthly_recharge: 'আমার মাসিক রিচার্জ',
    my_monthly_recharge_rule1: (coins) =>
      `১. রিচার্জ কয়েনের চ্যানেলগুলির মধ্যে রয়েছে: Google, Apple, Huawei + রিচার্জ লিঙ্ক (payermax, paypal) + অ্যাপে রিচার্জ এজেন্ট রিচার্জ কয়েন (রিচার্জ $1 = ${coins} কয়েন)`,
    my_monthly_recharge_rule2: '২. মুদ্রা ব্যবসায়ীরা রিচার্জ কার্যকলাপ পুরস্কারে অংশ নেন না',
    days: 'দিন',
    hours: 'ঘণ্টা',
    minutes: 'মিনিট',
    seconds: 'সেকেন্ড',
    'recharge_9.9': 'রিচার্জ $9.9',
    receive: 'গ্রহণ করুন',
    received: 'গ্রহণ করা হয়েছে',
    recharge_label: 'রিচার্জ',
    receive_successfully_toast:
      'সফলভাবে গ্রহণ করা হয়েছে, আপনার পুরস্কার আপনার ব্যাকপ্যাকে পাঠানো হয়েছে',
    receive_failed_toast: 'গ্রহণ ব্যর্থ, অনুগ্রহ করে পরে আবার চেষ্টা করুন',
    'recharge_49.9': 'রিচার্জ $49.9',
    recharge_100: 'রিচার্জ $100',
    top3_winners: 'শীর্ষ ৩ বিজয়ী',
    recharge_300: 'রিচার্জ $300',
    recharge_500: 'রিচার্জ $500',
    recharge_1000: 'রিচার্জ $1000',
    recharge_1500: 'রিচার্জ $1500',
    recharge_3000: 'রিচার্জ $3000',
    recharge_5000: 'রিচার্জ $5000',
    recharge_10000: 'রিচার্জ $10000',
    eid_al_adha_events_button_introduction_1: 'এই কার্যকলাপের চূড়ান্ত ব্যাখ্যার অধিকার Yayya এর',
    eid_al_adha_events_button_introduction_2: 'এই কার্যকলাপের APPLE এর সাথে কোনো সম্পর্ক নেই',
    nineAdd: 'রিচার্জ $9.9+',
    threeAdd: 'রিচার্জ $3000+',
    fiveAdd: 'রিচার্জ $500+',
    gift_icon_tost:
      'আপনি আপনার কাস্টমাইজড উপহার হিসাবে অফিসিয়ালকে আপনার নিজস্ব একচেটিয়া ভিডিও প্রদান করতে পারেন।',
    customized_gifts_title: 'কাস্টমাইজড উপহার',
  },
}



// WEBPACK FOOTER //
// src/pages/activity/hobiRecharge/lang.js